import type { IconData } from '@stacksjs/iconify-core'

export const otherUiKey: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10 12a6 6 0 0 1-1.743-.257L6 14H4v2H0v-4l4.257-4.257A6 6 0 1 1 10 12m.75-8a1.25 1.25 0 1 0 2.5 0a1.25 1.25 0 0 0-2.5 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiKey
